import type { ProductSettings } from '../../types/ProductSettings';

export const productSettingsBaseFeatureConfig: ProductSettings = {
    showAccountInfo: false,
    showFeesIncludedSetting: false,
    showTradingActivation: false,
    showTransactionConfirmation: false,
    showPortfolioNumber: true,
};
